import { render, staticRenderFns } from "./ShippingLabels.vue?vue&type=template&id=dedb32e4&scoped=true&"
import script from "./ShippingLabels.vue?vue&type=script&lang=js&"
export * from "./ShippingLabels.vue?vue&type=script&lang=js&"
import style0 from "./ShippingLabels.vue?vue&type=style&index=0&id=dedb32e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedb32e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VDivider,VImg})
